module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/contest_stats/nba/survive/1_double-double-f3a8470d51e6c23454e7a0f1ff769f63.svg";